import React from "react";
import anime from "animejs";
import config from "../config";
import Section from "../components/section/section";
import { useStore } from "../store";

export default function Intro() {
  const { section, setSection } = useStore();
  React.useEffect(() => {
    // code to run on component mount
    anime.timeline({ loop: false }).add({
      targets: "h1 span",
      opacity: [0, 1],
      easing: "easeInOutQuad",
      duration: 500,
      delay: (el, i) => 70 * (i + 1),
    });

    setTimeout(() => {
      anime.timeline({ loop: false }).add({
        targets: "h2 span",
        opacity: [0, 1],
        easing: "easeInOutQuad",
        duration: 300,
        delay: (el, i) => 40 * (i + 1),
      });
    }, 700);
  }, []);

  if (section !== null) return null;

  return (
    <Section name="intro">
      <div
        className="full"
        onClick={() => {
          localStorage.clear();
          setSection(config[0].section);
        }}
      ></div>
      <h1>
        {"Own your".split("").map((v, index) => (
          <span key={index}>{v}</span>
        ))}
        <br />
        {"future".split("").map((v, index) => (
          <span key={index}>{v}</span>
        ))}
      </h1>

      <hr className={"Animate Animate--fade-slow Animate--show"} />
      <h2>
        {"Immerse yourself".split("").map((v, index) => (
          <span key={index}>{v}</span>
        ))}
        <br />
        {"in the adventure...".split("").map((v, index) => (
          <span key={index}>{v}</span>
        ))}
      </h2>
    </Section>
  );
}
